import { BoxGeometry, Mesh, Vector3, use } from '@anov/3d-core'
import type { Object3D, OrbitControls, PerspectiveCamera, SceneControl } from '@anov/3d-core'
import type Player from '../player'

interface PropsType {
  character: Object3D
  characterRotateBox: Object3D
  camera: PerspectiveCamera
  player: Player
  sceneControl: SceneControl
}

export default class Camera_movement {
  camera: PerspectiveCamera
  character: Object3D
  currentPosition: Vector3
  currentLookat: Vector3
  characterRotateBox: Object3D
  control: any
  player: Player
  view: Mesh
  sceneControl?: SceneControl

  constructor({ character, camera, characterRotateBox, player, sceneControl }: PropsType) {
    this.character = character
    this.characterRotateBox = characterRotateBox
    this.camera = camera
    this.player = player
    this.sceneControl = sceneControl

    this.currentPosition = new Vector3()
    this.currentLookat = new Vector3()
    this.control = use.useScene(this.sceneControl).orbitControls

    const view = new Mesh(new BoxGeometry(1, 1, 1))
    this.character.add(view)

    view.position.add(new Vector3(0, 5, -15))

    this.view = view
  }

  private calculateIdealLookat() {
    const { x, y, z } = this.character.position
    const idealLookat = new Vector3(x, this.character.position.y + 3.4, z)

    return idealLookat
  }

  private updateCharacter() {
    const cameraPosition = new Vector3()
    this.camera.getWorldPosition(cameraPosition)

    const characterPosition = new Vector3()
    this.character.getWorldPosition(characterPosition)

    const direction = new Vector3()
    direction.subVectors(cameraPosition, characterPosition)
    direction.y = 0

    const angle = Math.atan2(direction.x, direction.z)

    this.character.rotation.y = angle + Math.PI
    this.characterRotateBox.rotation.y = angle + Math.PI
  }

  private updateCamera() {
    const position = new Vector3()
    this.view.getWorldPosition(position)

    const idealLookat = this.calculateIdealLookat()
    this.control.target = idealLookat;
    (this.control as OrbitControls).object.position.copy(position)
  }

  private updateNewPosition() {
    if (this.view && this.view.position) {
      this.updateCharacter()
      this.updateCamera()
    }
  }

  update(deltaT: number) {
    this.updateNewPosition()
  }
}
